export const TEMPLATE_SPREADSHEET_IDS = {
  'Roller - Feature - Hebrew': '1b5585b2-c69f-4a72-805d-da27e8d0e6aa',
  'Roller - Feature - Bilingual': '305f913b-d2e1-4dee-aaf9-23c204783450',
  'Roller - Short - Hebrew': '2d9aee3d-152a-4e68-9461-d4d3f6190be8',
  'Roller - Short - English': '24a81031-aa4a-432c-b965-f1bb016685e9',
  'Roller - Short - Bilingual': '310a6f5d-6a70-42e9-9605-f1560679269a',
  'Closing credits Sequence Bilingual (cards)': 'f77c2c03-75bd-4f34-873a-87164c67d3d6',
  'Closing credits Sequence Hebrew (cards)': '7e6250f9-9ac2-41e1-9398-98ab98b412c2',
  'Closing credits Sequence English (cards)': '766c793f-8507-4f43-9f30-eb7f8ac591c2',
  'Cards - Opening Sequence - Hebrew': '3823063d-e817-4db2-9cc4-7a44003c2291',
  'Cards - Opening Sequence - English': 'de86416a-3fba-4fb8-b633-9ecf0be56e35',
  'Cards - Opening Sequence - Bilingual': '4061cfbd-8106-482b-9cc4-2949d466a0da',

} as const;

export type TemplateName = keyof typeof TEMPLATE_SPREADSHEET_IDS;

export const TEMPLATE_NAMES: TemplateName[] = Object.keys(TEMPLATE_SPREADSHEET_IDS) as TemplateName[];

export function getTemplateSpreadsheetId(name: TemplateName): string {
  return TEMPLATE_SPREADSHEET_IDS[name];
}
